"use client";

import { useEffect, useState } from "react";
import { ArrowLeft, ArrowRight, Star } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Carousel, CarouselContent, CarouselItem, type CarouselApi } from "@/components/ui/carousel";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Googlereviewsshowcase() {
  const [api, setApi] = useState<CarouselApi>();
  const [current, setCurrent] = useState(0);
  const [count, setCount] = useState(0);
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const testimonials = [{
    quote: "Absolutely brilliant service from TM Plant in Carlisle. Took my lawn mower in and had it fully fixed within an hour. Professional, friendly, and clearly knows what he’s doing. Great price and top-quality results. Highly recommend!",
    name: "Joshua H.",
    location: "CARLISLE, UK — PATIO INSTALLATION",
    blend: "PATIO INSTALLATION",
    rating: 5,
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701933/img/testimonial_patio_project.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701933/img/testimonial_patio_project.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701933/img/testimonial_patio_project.png-wvc-sizes",
    alt: "Beautifully paved patio area in a residential garden"
  }, {
    quote: "Toby has been taking care of all our mowers, hedge cutters, strimmers, chainsaws, leaf blowers and other plant equipment for years. He is honest, reliable and very knowledgeable, we will not use anyone else for services or repairs now.The prices are fair too.",
    name: "William S.",
    location: "GLASGOW, UK",
    blend: "FENCING SERVICES",
    rating: 5,
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701933/img/testimonial_fencing_project.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701933/img/testimonial_fencing_project.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701933/img/testimonial_fencing_project.png-wvc-sizes",
    alt: "Newly installed wooden garden fencing"
  }, {
    quote: "I would like to warmly recommend the company TM plant in Carlisle. The service was very pleasant and professional from the very beginning. Using their services is a pure pleasure - everything was done perfectly, on time and with attention to every detail.",
    name: "Damian C.",
    location: "GLASGOW, UK",
    blend: "DRIVEWAY PAVING",
    rating: 5,
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701933/img/testimonial_driveway_project.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701933/img/testimonial_driveway_project.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701933/img/testimonial_driveway_project.png-wvc-sizes",
    alt: "Professional block paved driveway"
  }, {
    quote: "Exceptional garden design service. They listened to our ideas and brought them to life perfectly. Highly recommended.",
    name: "Tom W.",
    location: "GLASGOW, UK",
    blend: "GARDEN DESIGN",
    rating: 5,
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701933/img/testimonial_garden_design.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701933/img/testimonial_garden_design.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701933/img/testimonial_garden_design.png-wvc-sizes",
    alt: "Modern garden design with lush planting"
  }, {
    quote: "Reliable and skilled landscapers. They handled our planting project with great care and the results are beautiful.",
    name: "Claire B.",
    location: "GLASGOW, UK",
    blend: "PLANTING SERVICES",
    rating: 5,
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701933/img/testimonial_planting_project.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701933/img/testimonial_planting_project.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701933/img/testimonial_planting_project.png-wvc-sizes",
    alt: "Vibrant flower beds and shrubbery"
  }, {
    quote: "The best landscaping team in Glasgow. They turned our tired backyard into a peaceful retreat. Truly professional.",
    name: "David H.",
    location: "GLASGOW, UK",
    blend: "FULL GARDEN RENOVATION",
    rating: 5,
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701933/img/testimonial_renovation_project.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701933/img/testimonial_renovation_project.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701933/img/testimonial_renovation_project.png-wvc-sizes",
    alt: "Complete garden renovation project"
  }];
  useEffect(() => {
    if (!api) return;
    setCount(api.scrollSnapList().length);
    setCurrent(api.selectedScrollSnap());
    const onSelect = () => setCurrent(api.selectedScrollSnap());
    api.on("select", onSelect);
    return () => {
      api.off("select", onSelect);
    };
  }, [api]);
  const pad = (n: number) => String(n).padStart(2, "0");
  return <section data-section-id="465" id="googlereviewsshowcase" className="bg-background text-foreground py-20 md:py-28 px-4 md:px-8 lg:px-12">
      <div className="max-w-7xl mx-auto">
        <div ref={headerRef} className={["max-w-3xl mb-14 md:mb-20 transition-all duration-700 ease-out", headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"].join(" ")}>
          <p className="font-mono text-xs tracking-[0.25em] uppercase text-chart-2 mb-4">
            Client Testimonials
          </p>
          <h2 className="font-default font-serif text-4xl md:text-5xl lg:text-[48px] leading-[1.05] tracking-tight text-foreground mb-4">Trusted by Cumbria homeowners.</h2>
          
        </div>

        <Carousel setApi={setApi} opts={{
        align: "start",
        loop: true,
        dragFree: false
      }} className="w-full">
          <CarouselContent className="-ml-6">
            {testimonials.map((t, i) => <CarouselItem data-index={i} key={i} className="pl-6 basis-full md:basis-1/2 lg:basis-1/3">
                <article className={["group h-full rounded-[12px] border border-[rgba(65,158,231,0.2)] bg-gradient-to-b from-white to-[#f0f8ff] text-card-foreground overflow-hidden flex flex-col sm:flex-row shadow-[0_4px_12px_rgba(0,0,0,0.1)] transition-all duration-300 ease-in-out hover:shadow-[0_12px_24px_rgba(0,0,0,0.15)] hover:scale-105", i === 0 ? "ring-2 ring-[#419ee7]/30 z-10" : ""].join(" ")}>
                  {i === 0 && <div className="absolute top-4 right-4 z-20">
                      <span className="bg-[#419ee7] text-white text-[10px] font-bold px-2 py-1 rounded-md uppercase tracking-wider shadow-sm">
                        Featured Review
                      </span>
                    </div>}

                  <div className="sm:w-full p-[24px] flex flex-col justify-between relative">
                    <div className="relative">
                      <span aria-hidden="true" className="absolute -top-6 -left-1 font-serif text-[24px] leading-none text-[#419ee7] select-none pointer-events-none">
                        &ldquo;
                      </span>
                      <p className="relative font-default font-serif italic text-base md:text-lg leading-snug text-foreground pt-4">
                        {t.quote}
                      </p>
                    </div>

                    <div className="mt-[16px] pt-4 border-t border-border">
                      <div className="flex items-center gap-1 mb-3" aria-label={`Rating: ${t.rating} out of 5`}>
                        {Array.from({
                      length: t.rating
                    }).map((_, s) => <Star key={s} className="size-[18px]" style={{
                      color: '#419ee7',
                      fill: '#419ee7'
                    }} strokeWidth={1.5} />)}
                      </div>
                      <p className="font-default text-[16px] font-bold text-foreground mb-1.5">
                        {t.name}
                      </p>
                    </div>
                  </div>
                </article>
              </CarouselItem>)}
          </CarouselContent>

          <div className="mt-12 flex items-center justify-between gap-6">
            <div className="font-mono text-xs tracking-[0.25em] text-muted-foreground">
              <span className="text-foreground">{pad(current + 1)}</span>
              <span className="mx-2 text-border">/</span>
              <span>{pad(count || testimonials.length)}</span>
            </div>

            <div className="flex items-center gap-3">
              <Button type="button" variant="outline" size="icon" aria-label="Previous testimonial" onClick={() => api?.scrollPrev()} className="size-12 rounded-lg border border-border bg-transparent hover:bg-accent hover:text-accent-foreground transition-all duration-300 ease-in-out">
                <ArrowLeft className="size-4" strokeWidth={1.5} />
              </Button>
              <Button type="button" variant="outline" size="icon" aria-label="Next testimonial" onClick={() => api?.scrollNext()} className="size-12 rounded-lg border border-border bg-transparent hover:bg-accent hover:text-accent-foreground transition-all duration-300 ease-in-out">
                <ArrowRight className="size-4" strokeWidth={1.5} />
              </Button>
            </div>
          </div>
        </Carousel>
      </div>
    </section>;
}